var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5734_3714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.97473 0.505946C7.30473 0.505946 8.64458 0.505946 9.97458 0.505946C11.7184 0.515797 12.9597 1.78669 12.9695 3.57972C12.9794 5.41217 12.9695 7.25446 12.9695 9.08691C12.9695 9.95387 12.5558 10.3775 11.7085 10.3775C8.97954 10.3775 6.25058 10.3874 3.53147 10.3775C1.83695 10.3775 0.585767 9.10661 0.566063 7.36283C0.54636 5.48113 0.556212 3.59943 0.566063 1.71772C0.566063 0.929575 0.989693 0.496094 1.75814 0.496094C3.1571 0.505946 4.56592 0.505946 5.97473 0.505946Z",
    fill: "#744FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2253 5.46974C18.2253 6.74063 18.2154 8.01152 18.2253 9.27256C18.2253 9.72574 18.1071 10.1001 17.6736 10.307C17.2303 10.504 16.8756 10.3563 16.5308 10.0509C15.8313 9.42034 15.122 8.80952 14.4028 8.19871C14.0974 7.94256 13.9496 7.6273 13.9594 7.22337C13.9693 6.04115 13.9693 4.86878 13.9594 3.68656C13.9594 3.28263 14.0974 2.97723 14.4028 2.71123C15.1417 2.08071 15.8707 1.45019 16.5997 0.799966C16.9249 0.514262 17.2697 0.405892 17.6637 0.593077C18.0578 0.77041 18.2253 1.09552 18.2253 1.529C18.2154 2.8393 18.2253 4.1496 18.2253 5.46974Z",
    fill: "#744FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5734_3714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7333,
    height: 9.90111,
    fill: "white",
    transform: "translate(0.556641 0.496094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/video_call_icon.c1cf5fb58e47a5ecfe95cb588579fa41.svg";
export { ForwardRef as ReactComponent };